export default __webpack_public_path__ + "images/models/a69ae39ef7eacc66d387258280912b93.usdz";